(ns builder.sdc.posthog
  (:require [re-frame.core :as rf]))

(rf/reg-fx
 ::identify
 (fn [user-data]
   #?(:cljs
      (when (exists? js/posthog)
        (let [browser-distinct-id (.get_distinct_id js/posthog)
              user-id (:id user-data)]
          ;; Why: https://posthog.com/questions/change-distinct-id-1
          (try
            (.alias js/posthog browser-distinct-id user-id)
            (catch js/Object e (.log js/console e) false))
          (try
            (.identify js/posthog user-id (clj->js user-data))
            (catch js/Object e (.log js/console e) false)))))))

(rf/reg-event-fx
 ::identify
 (fn [_ [_ user-data]]
   {::identify user-data}))

(rf/reg-fx
 ::report-event
 (fn [{:keys [event properties]}]
   #?(:cljs
      (do
        ;; Send to PostHog
        (when (exists? js/posthog)
          (try
            (prn "report event to posthog: " properties)
            (.capture js/posthog event (clj->js properties))
            (catch js/Object e (.log js/console e) false)))
        ;; Send to dataLayer (GTM)
        (when (exists? js/window.dataLayer)
          (try
            (js/window.dataLayer.push (clj->js (merge {:event event} properties)))
            (catch js/Object e (.log js/console e) false)))))))

(rf/reg-event-fx
 ::report-event
 (fn [_ [_ properties]]
   {::report-event properties}))

(rf/reg-fx
 ::reset
 (fn [_]
   #?(:cljs
      (when (exists? js/posthog)
        (try
          (.reset js/posthog)
          (catch js/Object e (.log js/console e) false))))))

(rf/reg-event-fx
 ::reset
 (fn [_ _]
   {::reset {}}))
